import { Section } from 'components/Section';
import { isMobileLayout } from 'components/Shared/responsive';
import { useSelector } from 'react-redux';
import {
  getHeader,
  descriptionSelector,
  hasBrandContent,
  getExtendedDescription
} from 'views/ProductlistPage/selectors';
import { BrandContentTop } from '../BGH/brandContent';
import styles from './header.scss';
import { SeoSection } from 'views/ContentPage/components/themes/PP/seo';

export const Header = () => {
  const header = useSelector(getHeader);
  const description = useSelector(descriptionSelector);
  const isMobile = useSelector(isMobileLayout);
  const isBrandPage = useSelector(hasBrandContent);
  const extendedDescription = useSelector(getExtendedDescription);

  return (
    <Section className={styles.section} contentClassName={styles.header} full={isMobile}>
      {isBrandPage ? (
        <BrandContentTop />
      ) : (
        <SeoSection
          header={header}
          description={description}
          extendedDescription={extendedDescription}
          usePadding={false}
        />
      )}
    </Section>
  );
};
